import type { ActionStatus } from '../types/actions';

export function canStartClose(status: ActionStatus): boolean {
  return status === 'rectification_claimed';
}

export function isTerminalCloseStatus(status: ActionStatus): boolean {
  return status === 'verified_closed' || status === 'waived';
}

export function validateWaiver(acknowledged: boolean, reason: string): string | null {
  if (!acknowledged) {
    return 'Acknowledge that you are closing without closure evidence.';
  }
  if (reason.trim().length < 20) {
    return 'Add at least 20 characters explaining why you are closing without closure evidence.';
  }
  return null;
}

export function validateReopenNote(note: string): string | null {
  if (note.trim().length < 3) {
    return 'Add a short recheck note explaining what still needs correction.';
  }
  return null;
}
